import { Avatar, AvatarProps } from '@material-ui/core';

import {
  RiCodeLine as CodeIcon,
  RiGroupFill as GroupIcon,
  RiUserFill as PersonIcon,
  RiGlobalLine as PublicIcon,
  RiSettings3Fill as SettingsIcon,
} from '@remixicon/react';

import { IdentityRefFragment } from '@spotify/confidence-graphql';

import { IdentityKind, identityKind } from '../../utils';

export type IdentityAvatarProps = Omit<AvatarProps, 'children'> & {
  identityRef?: IdentityRefFragment | null;
};

const AVATAR_ICON_SIZE = '1.2em';

const getIcon = (kind: IdentityKind) => {
  switch (kind) {
    case 'user':
      return <PersonIcon size={AVATAR_ICON_SIZE} />;
    case 'apiClient':
      return <CodeIcon size={AVATAR_ICON_SIZE} />;
    case 'service':
      return <SettingsIcon size={AVATAR_ICON_SIZE} />;
    case 'group':
      return <GroupIcon size={AVATAR_ICON_SIZE} />;
    case 'everyone':
      return <PublicIcon size={AVATAR_ICON_SIZE} />;
    default:
      return null;
  }
};

export const IdentityAvatarBase = (
  props: IdentityAvatarProps & { avatarSrc?: string },
) => {
  const { identityRef, avatarSrc, ...avatarProps } = props;

  const kind = identityRef?.name ? identityKind(identityRef.name) : undefined;

  return (
    <Avatar
      {...(kind === 'user' ? { 'data-csr-block': true } : {})}
      {...avatarProps}
      src={avatarSrc}
      title={identityRef?.displayName ?? undefined}
    >
      {kind && getIcon(kind)}
    </Avatar>
  );
};
